var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ButtonPrimary',{staticClass:"order-button",attrs:{"label":_vm.buttonLabel,"disabled":_vm.isDisabled,"data-testid":"order-button"},on:{"click":_vm.defaultClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }